var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImpact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 37C35.2091 37 37 35.2091 37 33C37 30.7909 35.2091 29 33 29C30.7909 29 29 30.7909 29 33C29 35.2091 30.7909 37 33 37Z",
    fill: "#19D0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 60.2105C48.0279 60.2105 60.2105 48.028 60.2105 33C60.2105 17.9721 48.0279 5.78949 33 5.78949C17.972 5.78949 5.78943 17.9721 5.78943 33C5.78943 48.028 17.972 60.2105 33 60.2105Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 48.6316C41.6331 48.6316 48.6316 41.6331 48.6316 33C48.6316 24.3669 41.6331 17.3684 33 17.3684C24.3669 17.3684 17.3684 24.3669 17.3684 33C17.3684 41.6331 24.3669 48.6316 33 48.6316Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImpact);
export default __webpack_public_path__ + "static/media/icon_impact.de491bed61149e1ed17ce88feba63f4e.svg";
export { ForwardRef as ReactComponent };